import React from "react";
import "./ChangeStation.module.css";
import { useTranslation } from "react-i18next";

interface ChangeStationProps {
  message?: string;
}

const ChangeStation: React.FC<ChangeStationProps> = ({ message = "text" }: ChangeStationProps): React.JSX.Element => {

  const { t } = useTranslation(); // Use useTranslation hook

  return (
    <div className="gif">
      <img src="/img/fast-forward.gif" alt="Movement GIF" width={400} height={400} />
      <div className="text">{t(`stay.${message}`)}</div>
    </div>
  );
};

export default ChangeStation;